export default __webpack_public_path__ + "static/media/confused-dog.de248346.jpeg";